export const BASE_URL = "https://vs-server.fly.dev";
export const BASE_API = "/api/v1";
